import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { FilterInputDate, FilterInputSelect, FilterInputText } from '../../interfaces/crud-page.interface';
import { FormControl, FormGroup } from '@angular/forms';
import { ActionButtonClick, ActionsButtonTable, ColumnsTable, Paginator } from '../../interfaces/basic-table.interface';
import { BtnCrudBasic, Field, Type, TypeInput } from 'src/app/demo/interfaces/form-print.interface';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { DialogFormDynamicComponent } from 'src/app/demo/shared/dialog-form-dynamic/dialog-form-dynamic.component';
import { MenuItem } from 'primeng/api';

@Component({
  selector: 'app-crud-page',
  templateUrl: './crud-page.component.html',
  styleUrl: './crud-page.component.scss',
  providers: [
    DialogService
  ]
})
export class CrudPageComponent implements OnInit, OnChanges {
  formFilter: FormGroup = new FormGroup({
    filterText: new FormControl(null),
    filterSecondaryText: new FormControl(null),
    filterSelect: new FormControl(null),
    filterSecondarySelect: new FormControl(null),
    filterThirdSelect: new FormControl(null),
    filterDate: new FormControl(null)
  });
  questionsFilter: Field[] = [];
  dynamicDialogRef: DynamicDialogRef | undefined;
  @Input() titlePage: string = '';
  @Input() descriptionPage: string = '';
  @Input() filterInputText: FilterInputText = { show: true, label: 'Filtro texto' };
  @Input() filterInputSelect: FilterInputSelect = { show: true, label: 'Filtro select', options: [] };
  @Input() filterSecondaryInputText: FilterInputText = { show: false, label: 'Filtro texto secundario' };
  @Input() filterSecondaryInputSelect: FilterInputSelect = { show: false, label: 'Filtro select secundario', options: [] };
  @Input() filterThirdInputSelect: FilterInputSelect = { show: false, label: 'Filtro select tercero', options: [] };
  @Input() filterFourthInputSelect: FilterInputSelect = { show: false, label: 'Filtro select cuarto', options: [] };
  @Input() filterInputDate: FilterInputDate = { show: false, label: 'Filtro por fecha', type: 'single' };
  @Input() textButtonAdd: string = '';
  @Input() btnsCrudBasic: BtnCrudBasic[] = [];
  @Input() columnsTable: ColumnsTable[] = [];
  @Input() actionsTable: ActionsButtonTable[] = [];
  @Input() dataTable: any[] = [];
  @Input() configPaginator: Paginator | null;
  @Input() showDinamicFilterForm: boolean = false;
  @Input() questionsFilterForm: Field[] = [];
  @Input() buttonsActionsList: MenuItem[] = [];
  @Input() showClearFiltersFormDynamic: boolean = false;

  @Output() onSubmitFilterForm: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();
  @Output() onbtnsCrudBasic: EventEmitter<string> = new EventEmitter<string>();
  @Output() onClickButtonAdd: EventEmitter<void> = new EventEmitter<void>();
  @Output() onClickButtonTable: EventEmitter<ActionButtonClick> = new EventEmitter<ActionButtonClick>();
  @Output() onChangePaginator: EventEmitter<Paginator> = new EventEmitter<Paginator>();

  constructor(
    private dialogService: DialogService
  ) { }

  ngOnInit(): void {
    this.createFilterQuestions();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.createFilterQuestions();
  }

  /**
    * @author Ministerio de cultura
    * @createdate 2024-10-14
    * Metodo que limpia los filtros del formulario.
  */
  onClickClearFilter(): void {
    this.formFilter.reset();
    this.onSubmitFilterForm.emit(this.formFilter);
  }
  /**
    * @author Ministerio de cultura
    * @createdate 2024-10-14
    * Metodo que crea el formulario dinamico con la configuracion del formulario principal.
  */
  createFilterQuestions(): void {
    this.questionsFilter = [];
    if (this.filterInputText.show)
      this.questionsFilter.push({ label: this.filterInputText.label, key: 'filterText', typeInput: TypeInput.input, type: Type.text, value: null, show: true });
    if (this.filterSecondaryInputText.show)
      this.questionsFilter.push({ label: this.filterSecondaryInputText.label, key: 'filterSecondaryText', typeInput: TypeInput.input, type: Type.text, value: null, show: true });
    if (this.filterInputSelect.show)
      this.questionsFilter.push({ label: this.filterInputSelect.label, key: 'filterSelect', typeInput: TypeInput.select, type: Type.simple_select, value: null, show: true, options: this.filterInputSelect.options });
    if (this.filterSecondaryInputSelect.show)
      this.questionsFilter.push({ label: this.filterSecondaryInputSelect.label, key: 'filterSecondarySelect', typeInput: TypeInput.select, type: Type.simple_select, value: null, show: true, options: this.filterSecondaryInputSelect.options });

    if (this.filterThirdInputSelect.show)
      this.questionsFilter.push({ label: this.filterThirdInputSelect.label, key: 'filterThirdInputSelect', typeInput: TypeInput.select, type: Type.simple_select, value: null, show: true, options: this.filterThirdInputSelect.options });
    if (this.filterFourthInputSelect.show)
      this.questionsFilter.push({ label: this.filterFourthInputSelect.label, key: 'filterFourthInputSelect', typeInput: TypeInput.select, type: Type.simple_select, value: null, show: true, options: this.filterFourthInputSelect.options });
    
    if (this.filterInputDate.show) {
      this.questionsFilter.push({ label: this.filterInputDate.label, key: 'filterDate', typeInput: TypeInput.date, type: Type.range_date, value: null, show: true })
    }
    if (this.questionsFilterForm.length > 0) {
      this.questionsFilter = this.questionsFilterForm.map(question => {
        return { ...question, col: 'col-12' }
      });
    }
  }
  /**
    * @author Ministerio de cultura
    * @createdate 2024-10-14
    * Metodo que ejecuta la modal para renderizar el formulario dinamico.
  */
  onShowFormDialog(): void {
    this.dynamicDialogRef = this.dialogService.open(DialogFormDynamicComponent, {
      header: 'Buscar por...',
      modal: true,
      width: '30vw',
      data: {
        formData: null,
        questions: this.questionsFilter,
        textForm: 'Filtrar',
        hideAlert: true,
        apiString: null
      },
      contentStyle: this.questionsFilter.length > 2 ? { 'overflow': 'visible' } : { 'overflow': 'hidden' },
      breakpoints: {
        '960px': '50vw',
        '640px': '90vw'
      }
    });
    this.dynamicDialogRef.onClose.subscribe(res => {
      if (res) {
        this.formFilter = res;
        this.onSubmitFilterForm.emit(this.formFilter);
      } else {
        this.formFilter.reset();
        this.onSubmitFilterForm.emit(this.formFilter);
      }
    });
  }

  /** TODO
    * @author Ministerio de cultura
    * @createdate 2025-03-20
    * Metodo para filtrar la tabla basic-table
  */
  onSearch(event: any) {
    const query = event.target.value.toLowerCase();
  }
}